<template>
  <div class="Container">
    <div class="Cart">
      <div class="Cart-Items">
        <div class="Cart-Item"  v-for="item in items" :key="item.id">
          <div class="Image-Wrapper">
            <img class="Cart-Image" :src="imageSrc(item)" />
            <span class="Cart-Quantity">{{ item.quantity }}</span>
          </div>

          <span class="Title">{{ item.title }}</span>

          <span class="Price">{{ item.variant.price * item.quantity }}€</span>
        </div>
      </div>

      <div class="Recap" v-if="checkout">
        <div class="Subtotal">
          {{ $t('shop.cartInformations.subtotal') }}: {{ subTotal }} €
        </div>

        <div class="Discount">
          <vouchers />
        </div>

        <!-- <div class="Shipping" >
          <span v-if="requiresShipping">{{ $t('shop.cartInformations.shippingPrice') }}: {{ shippingPrice }}€</span>
        </div> -->

        <div class="Total">
          {{ $t('shop.cartInformations.total') }}: {{ total }}€
        </div>

      </div>
    </div>
    <div class="Cart-Cta" v-if="checkout">
      <div class="Submit" @click="goBack">
        {{ $t('global.back') }}
      </div>
      <div class="Submit" @click="submitCart">
        {{ $t('shop.cartInformations.submit') }}
      </div>
    </div>
  </div>
</template>

<script>
import shopMixin from '@/mixins/shop'
import userMixin from '@/mixins/user'
import Vouchers from '@/components/shop/Vouchers'

export default {
  name: 'CartSummary',
  components: { Vouchers },
  mixins: [shopMixin, userMixin],
  methods: {
    goBack() {
      this.$router.push({name: 'cart'})
    },
    submitCart() {
      // calculate nb total items
      let nbTotalItems = 0
      for (let i = 0; i < this.items.length; i++) {
        nbTotalItems += this.items[i].quantity
      }

      // track cart informations
      this.$gtm.trackEvent({
        event: 'go to payflow', // Event type [default = 'interaction'] (Optional)
        category: 'Shop',
        action: 'click',
        label: 'Cart informations',
        value: {
          userId: this.userId,
          total: parseFloat(this.total),
          nbItems: parseInt(nbTotalItems),
          meanValue: parseFloat(this.total / nbTotalItems),
          products: this.items.map(item => {
            return {
              id: item.id,
              title: item.title,
              quantity: item.quantity,
              price: parseFloat(item.variant.price),
              sku: item.variant.sku
            }
          }),
          payflowCompleted: false
        },
        noninteraction: false // Optional
      });

      var a = window.document.createElement('a');
      a.href = this.checkout.webUrl;
      a.setAttribute('target', '_blank');
      a.click();
    },
    imageSrc(item) {
      if (item.variant.image) {
        return item.variant.image.src
      }

      return 'https://cdn.shopify.com/shopifycloud/shopify/assets/checkout/product-blank-98d4187c2152136e9fb0587a99dfcce6f6873f3a9f21ea9135ed7f495296090f.png'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Container {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  @media (max-width: 768px) {
    margin-top: 40px;
    flex-direction: column;
  }

  .Cart {
    display: flex;
    flex-direction: row;

    @media (max-width: 768px) {
      flex-direction: column;
      width: 100%;
    }
  }

  .Cart-Items {
    display: flex;
    flex-direction: column;
    width: 60%;

    .Cart-Item {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 18px;
      // width: 100%;

      .Image-Wrapper {
        position: relative;
        max-width: 130px;
        max-height: 130px;
        min-width: 130px;
        width: 130px;
        height: 130px;

        @media (max-width: 768px) {
          width: 60px;
          height: 60px;
          max-height: 60px;
          min-width: 60px;
        }

        .Cart-Quantity {
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          right: -12px;
          top: -10px;
          border-radius: 36px;
          width: 27px;
          height: 27px;
          background-color: $primary;

          @media (max-width: 768px) {
            left: 50px;
            right: 0;
          }
        }
      }

      .Title {
        margin-left: 75px;
        font-weight: bold;
        width: 300px;

        @media (max-width: 768px) {
          margin-left: 50px;
        }
      }

      .Price {
        margin-left: 58px;

        @media (max-width: 768px) {
          margin-left: auto;
          float: right;
        }
      }

    }
    @media (max-width: 768px) {
      width: 100%;
    }

    .Cart-Image {
      max-width: 130px;
      max-height: 130px;
      width: 130px;
      height: 130px;

      @media (max-width: 768px) {
        width: 60px;
        height: 60px;
      }
    }
  }

  .Recap {
    width: 40%;
    display: flex;
    text-align: right;
    flex-direction: column;
    margin-top: 60px;

    @media (max-width: 768px) {
      width: 100%;
    }

    @media (max-width: 350px) {
      align-items: center;
      justify-content: space-evenly;
    }

    .Subtotal {
      font-size: 22px;
    }

    .Discount {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      vertical-align: center;
      margin-top: 26px;

      .Discount-Input {
        border: 4px solid $primary;
      }

      .Discount-apply {
        display: flex;
        background-color: $primary;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: bold;
        font-size: 20px;
        width: 145px;
      }
    }

    .Applied-Discounts {
      margin-top: 28px;
      font-size: 18px;
    }

    .Shipping {
      font-size: 18px;
      font-style: italic;
    }

    .Total {
      margin-top: 11px;
      font-size: 25px;
      font-weight: bold;
    }

    .Submit {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: auto;
      margin-top: 36px;
      width: 300px;
      height: 51px;
      font-weight: bold;
      font-size: 20px;
      color: white;
      background-color: $primary;
      border-radius: 26px;
      margin-bottom: 20px;
      cursor: pointer;

      @media (max-width: 768px) {
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  .Cart-Cta {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .Submit {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-top: 36px;
      max-width: 300px;
      height: 51px;
      font-weight: bold;
      font-size: 20px;
      color: white;
      padding-left: 20px;
      padding-right: 20px;
      background-color: $primary;
      border-radius: 26px;
      cursor: pointer;
    }
  }
}
</style>